import React from 'react'
import { Link } from 'react-router-dom'
import { useProducts } from '../context/ProductContext'

const ProductCard = ({ product }) => (
  <div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
    <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
      <Link
        to="/cart"
        className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
      >
        Add <i className="ph ph-shopping-cart" />
      </Link>
      <Link to="/product-details" className="product-card__thumb flex-center">
        <img
          src={product.img}
          alt={product.title}
          style={{ maxHeight: 140, objectFit: 'contain' }}
          onError={e => { e.target.src = 'assets/images/thumbs/product-img1.png'; }}
        />
      </Link>
      <div className="product-card__content mt-12">
        <div className="product-card__price mb-16">
          {product.discount > 0 && (
            <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
              ${product.oldPrice}
            </span>
          )}
          <span className="text-heading text-md fw-semibold">
            ${product.price} <span className="text-gray-500 fw-normal">/Qty</span>
          </span>
        </div>
        <div className="flex-align gap-6">
          <span className="text-xs fw-bold text-gray-600">{product.rating}</span>
          <span className="text-15 fw-bold text-warning-600 d-flex">
            <i className="ph-fill ph-star" />
          </span>
        </div>
        <h6 className="title text-lg fw-semibold mt-12 mb-8">
          <Link to="/product-details" className="link text-line-2">
            {product.title}
          </Link>
        </h6>
        {product.brand && (
          <div className="flex-align gap-4">
            <span className="text-main-600 text-md d-flex">
              <i className="ph-fill ph-storefront" />
            </span>
            <span className="text-gray-500 text-xs">By {product.brand}</span>
          </div>
        )}
      </div>
    </div>
  </div>
)

const ProductListOne = () => {
  const { products, loading } = useProducts()

  if (loading) {
    return (
      <div className="product mt-24">
        <div className="container container-lg">
          <div className="text-center py-40 text-gray-400">Loading products…</div>
        </div>
      </div>
    )
  }

  const display = products.length > 0 ? products.slice(0, 18) : []

  if (display.length === 0) return null

  return (
    <div className="product mt-24">
      <div className="container container-lg">
        <div className="row gy-4 g-12">
          {display.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProductListOne
